import * as React from 'react';
import { Component } from 'react';
import { LanguageService } from '../../services/LanguageService';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';

interface IProps {
    IsEditMode: boolean,
    OnRefreshRequired: () => void,
    Languages: string[]
}

interface IState {
    ShowAddNewLanguage: boolean,
    NewLang?: string,
    LoaderVisible: boolean
}

export class LanguagesComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAddNewLanguage: false,
            LoaderVisible: false
        }

        this.OnAddNewLanguageClick = this.OnAddNewLanguageClick.bind(this);
        this.OnAbort = this.OnAbort.bind(this);
        this.OnDeleteSuccess = this.OnDeleteSuccess.bind(this);
        this.OnDeleteError = this.OnDeleteError.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.OnSubmit = this.OnSubmit.bind(this);
        this.OnAddNewLangSuccess = this.OnAddNewLangSuccess.bind(this);
        this.OnAddNewLangError = this.OnAddNewLangError.bind(this);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
        if (this.state.ShowAddNewLanguage) {
            buttons = (
                <div className="buttons">
                    <button className="std-secondary-btn" onClick={this.OnAbort}>Anuluj</button>
                    <button type="submit" className="std-primary-btn">Dodaj</button>
                </div>
            );
            itemsElement = (
                <div className="input">
                    <form onSubmit={this.OnSubmit}>
                        <FormGroup validationState={this.GetInputValidationState()}>
                            <ControlLabel>Język:</ControlLabel>
                            <FormControl type="text" name="NewLang" onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                        </FormGroup>
                        {buttons}
                    </form>
                </div>
            );
        } else {
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <a onClick={this.OnAddNewLanguageClick}>Dodaj język</a>
                    </div>
                );
            }
            let items = this.props.Languages.map((lang) => (
                <li key={lang} className="language-item">
                    <span><b className="no-bold">{lang.toLowerCase()}</b></span>
                    {
                        this.props.IsEditMode ?
                            (<a className="delete-icon" onClick={this.RemoveLanguage.bind(this, lang)}>&nbsp;</a>) :
                            null
                    }
                </li>
            ));
            itemsElement = (
                <div className="input">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    {
                        items.length ?
                            (<ul>
                                {items}
                            </ul>) :
                            (<div className="info">
                                <p>
                                    Określ języki, którymi się posługujesz i w których możesz świadczyć usługi.
                                </p>
                            </div>)
                    }
                    {buttons}
                </div>
            );
        }
        return (
            <div className="form-row education-list">
                <label>Języki:</label>
                {itemsElement}
            </div>
        );
    }//end-of-render

    private GetInputValidationState(): 'success' | 'warning' | 'error' {
        if (this.state.NewLang) {
            if (this.state.NewLang.length > 0) {
                return 'success';
            } else {
                return 'error';
            }
        } else {
            return 'error';
        }
    }

    private OnAddNewLanguageClick(evt) {
        this.setState({
            ShowAddNewLanguage: true
        });
    }

    private OnAbort(evt) {
        this.setState({
            ShowAddNewLanguage: false
        });
    }

    private RemoveLanguage(lang: string) {
        this.setState({
            LoaderVisible: true
        });
        let service = new LanguageService();
        service.DeleteMyLanguage(lang, this.OnDeleteSuccess, this.OnDeleteError);
    }

    private OnDeleteSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Język usunięty', DEFAULT_STATUS_TIMEOUT);
    }

    private OnDeleteError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się usunąć języka. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnInputChange(event) {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

    private OnSubmit(evt) {
        if (this.state.NewLang) {
            if (this.GetInputValidationState() === 'success') {
                this.setState({
                    LoaderVisible: true
                });
                let service = new LanguageService();
                service.AddMyLanguage(this.state.NewLang, this.OnAddNewLangSuccess, this.OnAddNewLangError);
            }
        }
        evt.preventDefault();
    }

    private OnAddNewLangSuccess(result) {
        this.setState({
            ShowAddNewLanguage: false
        });
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Dodano język', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAddNewLangError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się dodać języka. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/Languages.tsx